// extracted by mini-css-extract-plugin
export default {"labelWrap":"Task01_labelWrap__4vSjh"};